(function () {
  var MOBILE_QUERY = "(max-width: 760px)";
  var signNames = ["Capricorn", "Aquarius", "Pisces", "Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo", "Libra", "Scorpio", "Sagittarius"];

  function zodiacName(month, day) {
    var boundaries = [20, 19, 21, 20, 21, 21, 23, 23, 23, 23, 22, 22];
    var index = day < boundaries[month - 1] ? month - 1 : month;
    return signNames[index % 12];
  }

  function init(root) {
    if (!root || root.dataset.mobileReady === "true") return;
    root.dataset.mobileReady = "true";
    root.setAttribute("data-mobile-sheet-state", "half");

    var handle = root.querySelector(".mobile-sheet-handle");
    var search = root.querySelector("#search-input");
    var matchToggle = root.querySelector("#match-float-toggle");
    var matchPanel = root.querySelector("#celestial-match");
    var summary = root.querySelector("#mobile-match-summary");
    var month = root.querySelector("#birth-month");
    var day = root.querySelector("#birth-day");
    var intention = root.querySelector("#intention");
    var dragStart = null;

    function isMobile() {
      return window.matchMedia(MOBILE_QUERY).matches;
    }

    function setSheetState(state) {
      if (!isMobile()) return;
      root.setAttribute("data-mobile-sheet-state", state);
      if (handle) handle.setAttribute("aria-expanded", String(state === "full"));
    }

    function updateSummary() {
      if (!summary || !month || !day || !intention) return;
      var monthValue = Number(month.value) || 1;
      var dayValue = Number(day.value) || 1;
      summary.textContent = zodiacName(monthValue, dayValue) + " · " + intention.value;
    }

    if (handle) {
      handle.addEventListener("click", function () {
        var current = root.getAttribute("data-mobile-sheet-state");
        setSheetState(current === "full" ? "half" : "full");
      });

      handle.addEventListener("pointerdown", function (event) {
        if (!isMobile()) return;
        dragStart = event.clientY;
        handle.setPointerCapture(event.pointerId);
      });

      handle.addEventListener("pointerup", function (event) {
        if (dragStart === null) return;
        var delta = event.clientY - dragStart;
        dragStart = null;
        if (Math.abs(delta) < 32) return;
        if (delta < 0) setSheetState("full");
        if (delta > 0) setSheetState("collapsed");
      });
    }

    if (search) search.addEventListener("focus", function () { setSheetState("full"); });
    if (matchToggle) {
      matchToggle.addEventListener("click", function () {
        if (!isMobile()) return;
        window.setTimeout(function () {
          setSheetState(root.querySelector("#celestial-match")?.classList.contains("is-open") ? "collapsed" : "half");
        }, 0);
      });
    }

    if (matchPanel) {
      var matchObserver = new MutationObserver(function () {
        if (!isMobile()) return;
        if (!matchPanel.classList.contains("is-open") && root.getAttribute("data-mobile-sheet-state") === "collapsed") {
          setSheetState("half");
        }
      });
      matchObserver.observe(matchPanel, { attributes: true, attributeFilter: ["class"] });
    }

    [month, day, intention].forEach(function (field) {
      if (field) field.addEventListener("change", updateSummary);
    });

    window.addEventListener("resize", function () {
      if (isMobile() && !root.getAttribute("data-mobile-sheet-state")) setSheetState("half");
    });

    updateSummary();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(".lunastra-diy-v3").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
})();
